import xws from 'api/xws/';
import { SET_DECLINED_SERVICES } from './actionTypes';
import { ERROR_DECLINED } from 'store/reducers/errors/actionTypes';

// Constants
import { getService } from 'constants/ajax';

// Selectors
import { getDeclinedServices as getDeclinedServicesFromStore } from 'store/reducers/declined/selectors';
import {
  getPersonId,
  getProperty
} from 'store/reducers/user/personInfo/selectors';
import { getWebkey, getQueryParam } from 'store/reducers/queryParams/selectors';
import { getLocaleCode } from 'store/reducers/dealerLocale/selectors';

import { SERVICES_KIND } from 'constants/services';

const { DECLINED } = SERVICES_KIND;

export const getDeclinedServices = () => async (dispatch, getState) => {
  if (getDeclinedServicesFromStore(getState()).length > 0) {
    return;
  }
  const {
    appointment: {
      vehicle: { vehicleId, vin }
    }
  } = getState();
  const personId = getPersonId(getState());
  const locale = getLocaleCode(getState());
  const extId =
    getProperty(getState(), 'extId') || getQueryParam('extId')(getState());
  try {
    const declinedService = getService(DECLINED);
    const webkey = getWebkey(getState());
    declinedService.setPathVars({ webkey });
    const {
      data: {
        declinedServices: { services, opcode, placeholderServiceId }
      }
    } = await xws(declinedService).post(declinedService.getPath(), {
      extId,
      locale,
      personId,
      vin,
      vehicleId
    });
    dispatch({
      type: SET_DECLINED_SERVICES,
      payload: services.map(service => ({
        opcode,
        parentPlaceholderId: placeholderServiceId,
        ...service
      }))
    });
  } catch (e) {
    // TODO (Arturo): add this dispatch when the call is refactored to called just
    // TODO: when we have the enough data similar like src/store/reducers/recall/actions.js:45
    dispatch({
      type: ERROR_DECLINED,
      payload: true
    });
    /* eslint-disable no-console */
    console.error(e);
    /* eslint-enable no-console */
  }
};

export const hasDeclinedServices = (vin, vehicleId, personId) => async (
  dispatch,
  getState
) => {
  try {
    const locale = getLocaleCode(getState());
    const extId =
      getProperty(getState(), 'extId') || getQueryParam('extId')(getState());
    const declinedService = getService(DECLINED);
    const webkey = getWebkey(getState());
    declinedService.setPathVars({ webkey });
    const { data } = await xws(declinedService).post(
      declinedService.getPath(),
      {
        extId,
        locale,
        personId,
        vin,
        vehicleId
      }
    );
    return data.declinedServices.services.length > 0;
  } catch (e) {
    /* eslint-disable no-console */
    console.error(e);
    /* eslint-enable no-console */
    return false;
  }
};

export const setDeclinedServices = declinedServices => ({
  type: SET_DECLINED_SERVICES,
  payload: declinedServices
});



// WEBPACK FOOTER //
// ./src/store/reducers/declined/actions.js